export default "__VITE_ASSET__6d450324__"